import { useEffect, useRef } from "react";

const WIDGET_URL = process.env.REACT_APP_WESHUB_WIDGET_URL || "";
const WIDGET_SURFACE = process.env.REACT_APP_WESHUB_WIDGET_SURFACE || "website";
const WIDGET_HIDE_WHEN = process.env.REACT_APP_WESHUB_WIDGET_HIDE_WHEN || "";
const SCRIPT_FLAG = "data-weshub-widget";

const widgetOrigin = () => {
  try {
    return new URL(WIDGET_URL, window.location.origin).origin;
  } catch (e) {
    return "";
  }
};

const widgetSrc = () => {
  try {
    const url = new URL(WIDGET_URL, window.location.origin);
    url.searchParams.set("v", Date.now());
    return url.toString();
  } catch (e) {
    return WIDGET_URL + (WIDGET_URL.includes("?") ? "&" : "?") + "v=" + Date.now();
  }
};

const removeWidgetNodes = () => {
  document.querySelectorAll(`script[${SCRIPT_FLAG}]`).forEach((node) => node.remove());

  const origin = widgetOrigin();
  const selectors = ['[id*="weshub" i]', '[class*="weshub" i]'];
  if (origin) selectors.push(`iframe[src^="${origin}"]`);

  document.querySelectorAll(selectors.join(",")).forEach((node) => {
    if (node.closest("#root")) return;
    node.remove();
  });
};

export const mountWeshubWidget = () => {
  if (!WIDGET_URL || typeof document === "undefined") return () => {};
  if (document.querySelector(`script[${SCRIPT_FLAG}]`)) return removeWidgetNodes;

  const script = document.createElement("script");
  script.src = widgetSrc();
  script.async = true;
  script.setAttribute("data-surface", WIDGET_SURFACE);
  if (WIDGET_HIDE_WHEN) script.setAttribute("data-hide-when", WIDGET_HIDE_WHEN);
  script.setAttribute(SCRIPT_FLAG, "true");
  document.body.appendChild(script);

  return removeWidgetNodes;
};

export const unmountWeshubWidget = removeWidgetNodes;

export function WesHubWidget({ enabled }) {
  const loaded = useRef(false);

  useEffect(() => {
    if (!enabled) {
      loaded.current = false;
      unmountWeshubWidget();
      return;
    }
    if (loaded.current) return;
    loaded.current = true;
    mountWeshubWidget();
  }, [enabled]);

  return null;
}
